// Platform-admin console header — admin identity + nav + sign-out. Shared across the
// authenticated admin screens (dashboard, orgs, audit). Web-only console, but uses only
// the shared design-system primitives so it typechecks/bundles on all platforms.
import React from 'react';
import { StyleSheet, View } from 'react-native';
import { useRouter } from 'expo-router';
import { Text, Button } from '../ui';
import { theme } from '../../theme';
import { useAdminSession } from '../../auth/adminSession';

type AdminHeaderProps = {
  /** Active nav target — its button renders in the filled (primary) style. */
  active?: 'dashboard' | 'orgs' | 'audit';
};

export function AdminHeader({ active }: AdminHeaderProps) {
  const router = useRouter();
  const admin = useAdminSession((s) => s.admin);
  const logout = useAdminSession((s) => s.logout);

  return (
    <View style={styles.wrap}>
      <View style={styles.titleRow}>
        <Text variant="subhead">BEAM platform admin</Text>
        {admin ? (
          <Text variant="small" color="secondary">
            {admin.email}
          </Text>
        ) : null}
      </View>
      <View style={styles.nav}>
        <Button
          title="Dashboard"
          size="sm"
          variant={active === 'dashboard' ? 'primary' : 'secondary'}
          fullWidth={false}
          onPress={() => router.replace('/admin')}
        />
        <Button
          title="Organizations"
          size="sm"
          variant={active === 'orgs' ? 'primary' : 'secondary'}
          fullWidth={false}
          onPress={() => router.replace('/admin/orgs')}
        />
        <Button
          title="Audit"
          size="sm"
          variant={active === 'audit' ? 'primary' : 'secondary'}
          fullWidth={false}
          onPress={() => router.replace('/admin/audit')}
        />
        <View style={styles.spacer} />
        <Button title="Sign out" size="sm" variant="ghost" fullWidth={false} onPress={() => void logout()} />
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  wrap: { gap: theme.spacing.md, paddingBottom: theme.spacing.md },
  titleRow: { flexDirection: 'row', alignItems: 'baseline', justifyContent: 'space-between', gap: theme.spacing.md, flexWrap: 'wrap' },
  nav: { flexDirection: 'row', alignItems: 'center', gap: theme.spacing.sm, flexWrap: 'wrap' },
  spacer: { flex: 1 },
});
